/**
 * Created by Andrey on 21.10.2026.
 */

// The game-side fraud detector: tells an ad farm from a player by what the install does in the game. Each detector
// (by code) watches one kind of suspicious action and triggers "hit", or "reset" on the normal action of the same kind.
// This class counts the hits of every detector in a row, traces them as fraud_hit / fraud_reset (itemId the code) so the
// thresholds are tuned in ClickHouse, and at the detector's threshold marks the install: cleverapps.user keeps the mark
// on the device and sends it with every event (events.fraud), the connector's attribution loggers and predictions are
// disabled (applyFraud, again on every launch), cleverapps.kpi reads the same mark. Only a paid install in its first
// month counts: an organic one costs the networks nothing to teach, an old one is not a farm install (the 2026 farms
// install, farm for days and leave)
class FraudDetector {
    constructor() {
        this.data = cleverapps.dataLoader.load(DataLoader.TYPES.FRAUD_DETECTOR) || {};

        this.detectors = {
            unplacedads: new UnplacedAdsFraud(),
            unstartedads: new UnstartedAdsFraud(),
            blockedads: new BlockedAdsFraud(),
            lowlevelsessions: new LowLevelSessionsFraud()
        };

        for (const code in this.detectors) {
            const detector = this.detectors[code];

            detector.on("hit", (value) => this.hit(code, value));
            detector.on("reset", () => this.reset(code));
        }
    }

    save() {
        cleverapps.dataLoader.save(DataLoader.TYPES.FRAUD_DETECTOR, this.data);
    }

    // a paid install inside the window the networks learn from: they optimise on d7/d30 ROAS and our predictions
    // count its revenue to d30, so a mark later than that changes nothing
    isApplicable() {
        return Date.now() - cleverapps.user.registered <= cleverapps.parseInterval(FraudDetector.WINDOW)
            && Boolean(cleverapps.user.channel);
    }

    hit(code, value = 1) {
        if (cleverapps.user.cheater || !this.isApplicable()) {
            return;
        }

        const count = (this.data[code] || 0) + value;
        this.data[code] = count;
        this.save();

        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.FRAUD_HIT, { value, itemId: code });

        if (count >= this.detectors[code].config.threshold) {
            cleverapps.user.setCheater(true);
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.FRAUD, { itemId: code });
        }
    }

    // a normal action of the same kind: a player who trips a rule once by accident never reaches the threshold
    reset(code) {
        if (!this.data[code]) {
            return;
        }

        delete this.data[code];
        this.save();

        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.FRAUD_RESET, { itemId: code });
    }
}

FraudDetector.WINDOW = "30 days";
